<style scoped>
    signal-chart {
        padding-bottom: 8px;
        display: flex;
        flex-basis: 0;
        flex-grow: 1;
    }

    signal-chart:first-child {
        padding-top: 8px;
    }

    [mwlResizable] {
        box-sizing: border-box;
    }

    .chart-holder {
        display: flex;
        flex-direction: column;
        --handle-height: 12px;
        min-height: calc(120px + var(--handle-height));
    }

    .chart-holder.mobile {
        --handle-height: 20px;
    }

    .resize-handle {
        height: var(--handle-height);
        flex-basis: var(--handle-height);
        flex-grow: 0;
        background-color: var(--ion-color-step-200);
        border-width: 1px 0;
        border-color: var(--ion-color-step-500);
        border-style: solid;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: row-resize;
    }

    .mobile .resize-handle {
        height: 20px;
        flex-basis: 20px;
    }

    .empty-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
        padding: 32px 16px;
        text-align: center;
    }

    .empty-state-hints {
        display: flex;
        flex-direction: column;
        gap: 4px;
        font-size: 0.85em;
        opacity: 0.6;
    }

    .empty-state-hints .shortcut {
        font-variant-numeric: tabular-nums;
        white-space: nowrap;
    }

    .resize-handle > .resize-handle-inner {
        height: 4px;
        width: 25%;
        flex-grow: 0;
        background-color: transparent;
        border-width: 1px 0;
        border-color: var(--ion-color-step-500);
        border-style: solid;
    }
</style>

@if (!isLoaded()) {
    <div class="empty-state">
        <ion-label class="wrapped ion-text-center"> Signals will appear here once a log file is loaded. </ion-label>
        <ion-button (click)="openLogFile()" fill="clear">
            <ion-icon slot="start" name="document-outline"></ion-icon>
            Open Log File
        </ion-button>
        <div class="empty-state-hints">
            <div>
                or press <span class="shortcut">{{ shortcutPrefix }}O</span>
            </div>
            <div>or drag a .hjl file anywhere onto the window</div>
        </div>
    </div>
}

@if (dataError()) {
    <ion-item class="wrapped" lines="full">{{ dataError() }}</ion-item>
}

@if (isLoaded() && !styledGroups.length) {
    <ion-item lines="full">
        <ion-label class="wrapped">No signals are selected, or the log file does not contain any data.</ion-label>
    </ion-item>
}

@for (group of styledGroups; track $index; let index = $index) {
    <div
        class="chart-holder"
        [class.mobile]="uiOptions.isMobile()"
        mwlResizable
        (resizing)="onChartResizing($event, group)"
        (resizeEnd)="onChartResizeEnd($event, group)"
        [style]="group.style"
    >
        <signal-chart
            [id]="index"
            [signals]="group"
            [signalsNoData]="styledGroupsNoData[index]"
            (isUpdating)="onChartIsUpdating($event, group)"
        />
        <div class="resize-handle" mwlResizeHandle [resizeEdges]="{ bottom: true }">
            <div class="resize-handle-inner"></div>
        </div>
    </div>
}
